import { useMemo } from "react";

/**
 * Valores válidos de estado normalizados.
 * Toda comparação no componente deve usar estas constantes.
 */
export const ESTADO = {
  COMPACTADO: "compactado",
  EGRESADO: "egresado",
  INGRESADO: "ingresado",
  A_COMPACTAR: "a compactar",
  NO_COMPACTAR: "no compactar",
  DESCONOCIDO: "desconocido",
};

/**
 * Deriva el estado actual del secuestro a partir de `detail`.
 * Normaliza el valor a minúsculas para evitar comparaciones inconsistentes
 * como "Desconocido" vs "desconocido".
 *
 * Orden de prioridad:
 *  1. Si detail.estado está seteado, se usa ese (normalizado).
 *  2. Si detail.compactado existe → "compactado".
 *  3. Si detail.egreso existe → "egresado".
 *  4. Fallback → "ingresado".
 *
 * @param {object} detail - El objeto de detalle del secuestro desde Redux.
 * @returns {{ estado: string, puedeCompactar: boolean }}
 */
export function useEstado(detail) {
  const estado = useMemo(() => {
    if (detail?.estado != null) {
      return detail.estado.toLowerCase().trim();
    }
    if (detail?.compactado != null) return ESTADO.COMPACTADO;
    if (detail?.egreso != null) return ESTADO.EGRESADO;
    return ESTADO.INGRESADO;
  }, [detail?.estado, detail?.compactado, detail?.egreso]);

  const puedeCompactar = useMemo(() => {
    return (
      detail?.infoJuzgado === null ||
      detail?.infoJuzgado?.compactar === true
    );
  }, [detail?.infoJuzgado]);

  return { estado, puedeCompactar };
}